// icons
import { useContext } from "react";
import { IoArrowForward, IoCartOutline, IoClose } from "react-icons/io5";
// context
import { CartContext } from "../context/CartContext";
// components
import CartItem from "../components/CartItem";
import { formatPrice } from "../lib/formatPrice";

export default function Cart() {
  const { setIsOpen, cart, total, clearCart } = useContext(CartContext);

  return (
    <div className="w-full h-full px-4 text-ink flex flex-col">
      <button
        type="button"
        onClick={() => setIsOpen(false)}
        aria-label="Close cart"
        className="text-4xl w-20 h-[98px] flex justify-start items-center cursor-pointer text-ink hover:text-brand transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded">
        <IoClose />
      </button>

      {cart.length >= 1 ? (
        <>
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="flex flex-col gap-y-10 px-2 pb-6">
              {cart.map((item, index) => (
                <CartItem item={item} key={`${item._id}-${index}`} />
              ))}
            </div>
          </div>
          <div className="border-t border-border px-6 py-8">
            <div className="flex justify-between text-lg text-muted mb-1">
              <div>Subtotal</div>
              <div>{formatPrice(total)}</div>
            </div>
            <div className="flex justify-between text-2xl font-semibold mb-6">
              <div>Total</div>
              <div>{formatPrice(total)}</div>
            </div>
            <div className="flex flex-col gap-y-3">
              {/* display-only — checkout is not wired up */}
              <button
                type="button"
                className="btn btn-accent w-full gap-x-2">
                <IoArrowForward className="text-lg" /> Check out
              </button>
              <button
                onClick={() => clearCart()}
                className="btn bg-canvas text-ink border border-border hover:bg-surface w-full">
                Clear cart
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="flex-1 flex justify-center items-center flex-col text-muted gap-y-2">
          <div className="text-2xl">Your cart is empty</div>
          <div className="text-6xl">
            <IoCartOutline />
          </div>
        </div>
      )}
    </div>
  );
}
